const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

// AfterShip Returns line item properties
const AFTERSHIP_PROPERTIES = {
  ENABLE_FINAL_SALE_PROPERTY: true,
  FINAL_SALE_KEY: '_ASRC',
  FINAL_SALE_VALUE: 'Final Sale'
};

function getFinalSaleProductTypes() {
  const value = window.finalSaleProductTypes;
  if (Array.isArray(value)) return value;
  if (typeof value === 'string' && value.trim()) return [value];
  return [];
}

function normalizeProductType(value) {
  return String(value == null ? '' : value).trim().toLowerCase();
}

function isListedFinalSaleProductType(productType) {
  const allowedTypes = getFinalSaleProductTypes();
  if (!allowedTypes.length) return false;

  const normalized = normalizeProductType(productType);
  if (!normalized) return false;

  return allowedTypes.some((type) => normalizeProductType(type) === normalized);
}

function isOnSaleCompareAt(compareAtPrice, price) {
  const compareAt = Number(compareAtPrice);
  const currentPrice = Number(price);
  return Boolean(compareAtPrice) && Boolean(price) && compareAt > currentPrice;
}

function isFinalSaleTypeExemptElement(element) {
  return !!(element && element.getAttribute('data-final-sale-exempt') === 'true');
}

function shouldSetFinalSaleProperty(compareAtPrice, price, productType, exemptFromTypeFinalSale) {
  try {
    if (typeof AFTERSHIP_PROPERTIES === 'undefined' || !AFTERSHIP_PROPERTIES.ENABLE_FINAL_SALE_PROPERTY) {
      return false;
    }
    if (isOnSaleCompareAt(compareAtPrice, price)) return true;
    if (exemptFromTypeFinalSale) return false;
    return isListedFinalSaleProductType(productType);
  } catch (e) {
    console.error('Final sale property check failed:', e);
    return false;
  }
}

function findProductTypeForFinalSale(productId) {
  try {
    if (!productId) return '';

    const wrapper = document.querySelector(`.product-list__noscript-wrapper-${productId}`);
    if (wrapper) {
      const productType = wrapper.getAttribute('data-product-type');
      if (productType) return productType;
    }

    const sizeSelector = document.querySelector(`.size-selector[data-product-id="${productId}"]`);
    if (sizeSelector) {
      const productType = sizeSelector.getAttribute('data-product-type');
      if (productType) return productType;
    }
  } catch (e) {
    console.error('Final sale product type lookup failed:', e);
  }

  return '';
}

function findFinalSaleTypeExempt(productId) {
  try {
    if (!productId) return false;

    const wrapper = document.querySelector(`.product-list__noscript-wrapper-${productId}`);
    if (isFinalSaleTypeExemptElement(wrapper)) return true;

    const sizeSelector = document.querySelector(`.size-selector[data-product-id="${productId}"]`);
    if (isFinalSaleTypeExemptElement(sizeSelector)) return true;
  } catch (e) {
    console.error('Final sale type exemption lookup failed:', e);
  }

  return false;
}
